import { Env } from "@emed-labs/virtual-lab-models";

export class Config {
	static APP_NAME = new Env.Option<string>("APP_NAME", Env.Converter.toString);
	/**
	 * Should be the git commit hash, injected by terraform
	 */
	static APP_VERSION = new Env.Option<string>("APP_VERSION", Env.Converter.toString);
	/**
	 * local, development, staging, production
	 */
	static ENVIRONMENT = new Env.Option<string>("ENVIRONMENT", Env.Converter.toString);
	static JURISDICTION = new Env.Option<string>("JURISDICTION", Env.Converter.toString);
	static CORALOGIX_RUM_KEY = new Env.Option<string>("CORALOGIX_RUM_KEY", Env.Converter.toString);
	/**
	 * Coralogix domain
	 * "EU1" | "EU2" | "US1" | "AP1" | "AP2"
	 */
	static CORALOGIX_DOMAIN = new Env.Option<string>("CORALOGIX_DOMAIN", Env.Converter.toString);
	static SEND_METRICS_THROTTLE_SECONDS = new Env.Option<number>(
		"SEND_METRICS_THROTTLE_SECONDS",
		Env.Converter.toNumber
	);
	/**
	 * For use with LoggerContext.
	 *
	 * SCOPE:LOWERCASE_LEVEL
	 *
	 * Example:
	 * "*:debug,aws:warn"
	 */
	static LOG_LEVELS = new Env.Option<string>("LOG_LEVELS", Env.Converter.toString);
	static SCRIPTS_BASE_URL = new Env.Option<string>("VLAB_SCRIPTS_CDN_BASE_URL", Env.Converter.toString);

	/**
	 * AWS Connect
	 */
	static AWS_CONNECT_INSTANCE_ALIAS = new Env.Option<string>("AWS_CONNECT_INSTANCE_ALIAS", Env.Converter.toString);
	static AWS_CONNECT_IAM_ROLE = new Env.Option<string>("AWS_CONNECT_IAM_ROLE", Env.Converter.toString);
	static AWS_CONNECT_INSTANCE_ID = new Env.Option<string>("AWS_CONNECT_INSTANCE_ID", Env.Converter.toString);
	static AWS_CONNECT_URL = new Env.Option<string>("AWS_CONNECT_URL", Env.Converter.toString);
	static AWS_CONNECT_REGION = new Env.Option<string>("AWS_CONNECT_REGION", Env.Converter.toString);
	static AWS_CONNECT_TRAINING_CONTACT_FLOW = new Env.Option<string>(
		"AWS_CONNECT_TRAINING_CONTACT_FLOW",
		Env.Converter.toString
	);

	static PHOTO_GET_RETRY_MS = new Env.Option<number>("PHOTO_GET_RETRY_MS", Env.Converter.toNumber);
	static ATTACHMENT_UPLOAD_TIMEOUT = new Env.Option<number>("ATTACHMENT_UPLOAD_TIMEOUT", Env.Converter.toNumber);
	static CONNECT_HEARTBEAT_TIMEOUT = new Env.Option<number>("CONNECT_HEARTBEAT_TIMEOUT", Env.Converter.toNumber);

	/**
	 * Flags
	 */

	static FLAG_IMAGING_SCALE_IMAGES = new Env.Option<boolean>("FLAG_IMAGING_SCALE_IMAGES", Env.Converter.toBoolean);
	static FLAG_IMAGING_IS_CLIENT_DETECTIONS_ENABLED = new Env.Option<boolean>(
		"FLAG_IMAGING_IS_CLIENT_DETECTIONS_ENABLED",
		Env.Converter.toBoolean
	);
	static IMAGING_CDN_URL = new Env.Option<string>("IMAGING_CDN_URL", Env.Converter.toString);
	static FLAG_ENABLE_VIDEO_RECORDING = new Env.Option<boolean>("FLAG_ENABLE_VIDEO_RECORDING", Env.Converter.toBoolean);
	static FLAG_ALLOW_SKIP_DEVICE_READINESS_CHECK = new Env.Option<boolean>(
		"FLAG_ALLOW_SKIP_DEVICE_READINESS_CHECK",
		Env.Converter.toBoolean
	);
	static FLAG_ENABLE_IOS_EMED_GETUSERMEDIA_PERMISSION = new Env.Option<boolean>(
		"FLAG_ENABLE_IOS_EMED_GETUSERMEDIA_PERMISSION",
		Env.Converter.toBoolean
	);
	static FLAG_ENABLE_TRAINING_ENVIRONMENT = new Env.Option<boolean>(
		"FLAG_ENABLE_TRAINING_ENVIRONMENT",
		Env.Converter.toBoolean,
		undefined,
		false
	);
	/**
	 * Enable the training proctor select screen only when the TRAINING ENVIRONMENT is enabled.  Disabling this
	 * will make the experience more like the production environment.
	 */
	static FLAG_ENABLE_TRAINING_PROCTOR_SELECT = new Env.Option<boolean>(
		"FLAG_ENABLE_TRAINING_PROCTOR_SELECT",
		Env.Converter.toBoolean,
		undefined,
		false
	);
	static FLAG_IS_LOCAL_DEVELOPMENT = new Env.Option<boolean>("FLAG_IS_LOCAL_DEVELOPMENT", Env.Converter.toBoolean);
	static FLAG_AUTOPICK_LAST_CONNECT_AGENT = new Env.Option<boolean>(
		"FLAG_AUTOPICK_LAST_CONNECT_AGENT",
		Env.Converter.toBoolean
	);
	static FLAG_DISABLE_CORALOGIX_RUM = new Env.Option<boolean>("FLAG_DISABLE_CORALOGIX_RUM", Env.Converter.toBoolean);
	static FLAG_HTTP_CLIENT_DEBUG = new Env.Option<boolean>("FLAG_HTTP_CLIENT_DEBUG", Env.Converter.toBoolean);

	/**
	 * Do not sent metrics to Coralogix
	 */
	static FLAG_DISABLE_SEND_METRICS = new Env.Option<boolean>("FLAG_DISABLE_SEND_METRICS", Env.Converter.toBoolean);

	/**
	 * For local development only
	 */
	static VLAB_API_URL = new Env.Option<string>("VLAB_API_URL", Env.Converter.toString);

	/**
	 * for vlab-web
	 */

	static GLOBAL_PROCTOR_WEB_DOMAIN = new Env.Option<string>("GLOBAL_PROCTOR_WEB_DOMAIN", Env.Converter.toString);
	static GLOBAL_PROCTOR_UI_ORIGIN = new Env.Option<string>("GLOBAL_PROCTOR_UI_ORIGIN", Env.Converter.toString);

	/**
	 * For vlab-web-global-proctor
	 */
	static ALLOWED_PROCTOR_APPLICATION_ORIGINS = new Env.Option<string>(
		"ALLOWED_PROCTOR_APPLICATION_ORIGINS",
		Env.Converter.toString
	);

	/**
	 * For Binah.ai
	 */
	static BINAH_LICENSE_KEY = new Env.Option<string>("BINAH_LICENSE_KEY", Env.Converter.toString);

	/**
	 * Map of procedureID to procedureName/version
	 *
	 * Allows for a single procedureID to map to a specific procedure version.
	 *
	 * If not set, the procedureID will be used as the procedureName
	 *
	 * Example:
	 {
		"uk-shemed-standalone-blood-collection": "uk-shemed-standalone-blood-collection/v2",
		"uk-shemed-glp1-onboarding-tasso": "uk-shemed-glp1-onboarding-tasso/v2",
	 }
	 */
	static VLAB_PROCEDURE_MAP = new Env.Option<{
		[key: string]: string;
	}>("VLAB_PROCEDURE_MAP", Env.Converter.toJsonObject);

	static SENTRY_DSN = new Env.Option<string>("SENTRY_DSN", Env.Converter.toString);
	static SENTRY_RELEASE = new Env.Option<string>("SENTRY_RELEASE", Env.Converter.toString);
	static SENTRY_ENVIRONMENT = new Env.Option<string>("SENTRY_ENVIRONMENT", Env.Converter.toString);
}
